export default "__VITE_ASSET__DTA7tQyh__"